// ─── View Mode Utilities ──────────────────────────────────────────────────────
import {
  ZapIcon,
  SmileIcon,
  WindIcon,
  LayoutGridIcon
} from 'lucide-react';
export type ViewMode = 'energy' | 'comfort' | 'aqi' | 'devices' | 'temperature' | 'airquality';

export interface ViewModeConfig {
  id: ViewMode;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  color: string;
  activeColor: string;
}

export const VIEW_MODES: ViewModeConfig[] = [
  {
    id: 'energy',
    label: 'view_modes.energy.title',
    icon: ZapIcon,
    color: 'text-slate-400',
    activeColor: 'text-amber-400',
  },
  {
    id: 'comfort',
    label: 'view_modes.comfort.title',
    icon: SmileIcon,
    color: 'text-slate-400',
    activeColor: 'text-emerald-400',
  },
  {
    id: 'aqi',
    label: 'view_modes.aqi.title',
    icon: WindIcon,
    color: 'text-slate-400',
    activeColor: 'text-violet-400',
  },
  {
    id: 'devices',
    label: 'view_modes.devices.title',
    icon: LayoutGridIcon,
    color: 'text-slate-400',
    activeColor: 'text-cyan-400'
}
];
